import { useGetCurrentWorkspaceDetail } from "../../api/workspace";
import { IAdsMenuItem } from "../../containers/IntegrationPage/IntegrationMenu/IntegrationMenu";
import { getSelectedAdProviders } from "../../utils/getSelectedAdProviders";

export const useGetSelectedAdProviders = (): IAdsMenuItem[] => {
  const { data: workspaceDetailData } = useGetCurrentWorkspaceDetail();
  return getSelectedAdProviders(workspaceDetailData);
};
